module.exports = __webpack_public_path__ + "img/Wp_2054.03baf99a.png";